import { styled } from 'styled-components';

import { cssBreakpoints, maxWidth } from '#/theme/theme';

export const SearchBodyHolder = styled.div`
  position: relative;
  max-width: ${maxWidth[3]}px;
  margin: 0 auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: flex;
    margin-top: 24px;
    padding-bottom: 48px;
    padding-top: 24px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    background: white;
    box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
    border-radius: 12px;
  }
`;
